<container-padrao>

    <div class="gerando-devolutiva" *ngIf="showLoader">

        <h2>Gerando devolutiva</h2>

        <p>
            Estamos processando as informações e montando o documento.
            Isso pode levar alguns instantes.
        </p>

        <loader-page [show]="true"></loader-page>
    </div>

    <div *ngIf="htmlDevolutiva">
        <div [innerHtml]="htmlDevolutiva"></div>
    </div>

    <div *ngIf="mensagemErro">
        <h2>❌ Não foi possível gerar a devolutiva</h2>
        <p>{{mensagemErro}}</p>
    </div>
    

</container-padrao>